// NOTE: refer to [Ant Design Button API](https://ant.design/components/button#api)
import * as React from "react"
import { Button, Tooltip } from "antd"
import { PlusOutlined, MinusOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import "./PrimeButton.scss"

export const primeButtonTypes = ["default", "primary", "add", "minus", "dashed", "link"]

const PrimeButton = React.forwardRef(function PrimeButton(
  {
    type: typeProp,
    size = "middle",
    tooltip,
    icon,
    dataTour, // to add as a walthrough step
    children,
    className,
    ...props
  },
  ref
) {
  const getIcon = (iconType) => {
    if (icon) {
      return icon
    }
    switch (iconType) {
      case "add":
        return <PlusOutlined />
      case "minus":
        return <MinusOutlined />
    }
  }

  const getType = (typeProp) => {
    if (typeProp === "add" || typeProp === "minus") {
      return "primary"
    } else if (typeProp) {
      return typeProp
    } else {
      return "default"
    }
  }

  const button = (
    <Button
      ref={ref}
      type={getType(typeProp)}
      size={size}
      icon={getIcon(typeProp)}
      className={`prime-button${className ? ` ${className}` : ""}`}
      {...props}
    >
      {children}
    </Button>
  )

  if (tooltip) {
    return <Tooltip title={tooltip}>{button}</Tooltip>
  }

  if (dataTour) {
    return <div data-tour={dataTour}>{button}</div>
    // return <div ref={ref} data-tour={dataTour}>{button}</div>
  }

  return button
})

PrimeButton.propTypes = {
  type: PropTypes.oneOf(primeButtonTypes),
  size: PropTypes.oneOf(["small", "middle", "large"]),
  tooltip: PropTypes.string,
  icon: PropTypes.node,
  shape: PropTypes.oneOf(["circle", "round"]),
  dataTour: PropTypes.string,
  children: PropTypes.node,
}

export default PrimeButton
